import * as React from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent
} from "@mui/material";
import Button from "@mui/material/Button";
import {ReactState} from "./Forms";
import {useTranslate} from "@tolgee/react";
import Stack from "@mui/material/Stack";
import FromMarkdown from "./Representation";

export const CS_KEY = "cs";
export const DS_KEY = "ds";
export const BI_KEY = "bi";

export function MarburgBachelorDialog(props: {
    dialogOpenState: ReactState<boolean>,
    action: (bachelorSubject: string | undefined) => void
}) {

    const [dialogOpen, setDialogOpen] = props.dialogOpenState;
    const {t} = useTranslate();

    const [bachelorSubject, setBachelorSubject] = React.useState<string>("");

    return (
        <Dialog
            open={dialogOpen}
            // TransitionComponent={Transition}
            keepMounted
            onClose={() => setDialogOpen(false)}
            aria-describedby="alert-dialog-slide-description"
            closeAfterTransition={false}
        >
            <DialogTitle>{t("marburg_bachelor_dialog_title")}</DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <FromMarkdown>{t("marburg_bachelor_dialog_content.markdown")}</FromMarkdown>
                    <FormControl fullWidth>
                        <InputLabel id="marburg_bachelor_select_label">{t("marburg_bachelor_label")}</InputLabel>
                        <Select
                            labelId="marburg_bachelor_select_label"
                            id="marburg_bachelor_select"
                            value={bachelorSubject}
                            label={t("marburg_bachelor_label")}
                            onChange={(event: SelectChangeEvent) => {
                                setBachelorSubject(event.target.value as string);
                            }}
                        >
                            <MenuItem value={CS_KEY}>{t("bachelor_cs")}</MenuItem>
                            <MenuItem value={DS_KEY}>{t("bachelor_ds")}</MenuItem>
                            <MenuItem value={BI_KEY}>{t("bachelor_bi")}</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setDialogOpen(false)}>{t("cancel")}</Button>
                <Button onClick={() => {
                    setDialogOpen(false);
                    props.action(bachelorSubject);
                }}>{t("ok")}</Button>
            </DialogActions>
        </Dialog>);
}

